// 注册自定义组件渲染器
import { registerRendererByType } from '@/utils/amis-widget/index.esm.js'
import Debug from './debug.vue'

registerRendererByType(Debug, {
  type: 'Debug',
  usage: 'renderer',
  weight: 99,
  framework: 'vue'
})
